module.exports = __webpack_public_path__ + "img/application2.474b3cbf.png";